// @flow

import {ON_RESIZE_CLASSNAME, TOGGLE_CLASS_ACTIONS} from '../constants';

export const toggleDocumentResizeClassName = (
    action: $Values<typeof TOGGLE_CLASS_ACTIONS> = TOGGLE_CLASS_ACTIONS.add
) => {
    const docElement = document.documentElement;

    if (docElement) {
        if (action === TOGGLE_CLASS_ACTIONS.add) {
            docElement.classList.add(ON_RESIZE_CLASSNAME);
        } else {
            docElement.classList.remove(ON_RESIZE_CLASSNAME);
        }
    }
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
